const userRoles = {
	Admin: 'Admin',
};

const userRoleLabels = {
	[userRoles.Admin]: 'Admin',
};

export default userRoles;
export { userRoleLabels };
